import { styled } from 'styled-components';
import { DisableSelection } from 'styles/Styles';

export const Button = styled.button<{
  $color?: string;
  $negative?: boolean;
  $transparent?: boolean;
  $width?: string;
  $widthSM?: string;
  $height?: string;
  $heightSM?: string;
}>`
  /* width: 100%; */
  height: 35px;
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  border-radius: ${({ $height }) => ($height === '50px' ? '12px' : '5px')};
  padding: 0 30px;
  background-color: ${({ theme, $color }) => ($color ? $color : theme.white)};
  color: ${({ theme }) => theme.black};
  border: none;
  cursor: pointer;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  ${(props) => props.disabled && `opacity: 0.5;`}

  ${(props) => props.disabled && `cursor: not-allowed`};

  ${({ $negative, theme }) =>
    $negative &&
    `
      background-color: ${theme.black};
      color: ${theme.white};
  border: 1px solid ${theme.white};

  
  `}

  ${({ $transparent }) =>
    $transparent &&
    `
      background-color: transparent;
     
    `}

  transition: transform 0.1s ease, background-color 0.3s ease, border 0.3s ease,
    color 0.3s ease;

  :active {
    transform: translateY(3px);
  }
  > * {
    ${DisableSelection}
  }

  @media (max-width: 800px) {
    width: ${({ $widthSM }) => $widthSM};
    height: ${({ $heightSM }) => $heightSM};
  }
`;
